import { ProductScreenshot } from 'components/ProductScreenshot';
import ImgFeatureFlagControlLight from "../../../../contents/images/docs/session-replay/select-replay-control-flag.png";
import ImgSampleConfigLight from "../../../../contents/images/tutorials/limit-session-recordings/sampling-config.png";
import ImgMinDurationLight from "../../../../contents/images/tutorials/limit-session-recordings/min-duration.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  ImgFeatureFlagControlLight,
  ImgSampleConfigLight,
  ImgMinDurationLight,
  React
};